// @ts-nocheck
import download_file from "includes/dl_file";
import formatDate from "includes/formatDate";
import { t } from "i18next";

export default function exportFormAnswers(
	file_name,
	Questions,
	Answers,
	anonymous,
	Users
) {
	var universalBOM = "\uFEFF";
	let header = Questions.sort((a, b) =>
		a.position < b.position ? -1 : 1
	).map((a) => `"${a.title}"`);
	if (!anonymous && Users)
		header.unshift(t("User.FIRST_NAME"), t("User.LAST_NAME"));
	header.unshift("Date");
	let separator = ";";
	let list = genList(Questions, Answers, anonymous, Users, separator);
	const csv = [
		header.join(separator), // header row first
		...list.map((row) => row.join(separator)),
	].join("\r\n");
	download_file(
		universalBOM + csv,
		file_name || "Answers export",
		"text/csv;charset=utf-8;"
	);
}

function genList(questions, answers, anonymous, users, separator) {
	let ret = [];

	const replacer = (key, value) => (value === null ? "" : value);

	answers.forEach((a) => {
		let row = [formatDate(a.answers[0]?.lastChanged, "D-M-Y h:m")];
		if (!anonymous && users?.length) {
			let user = users.find((u) => a.employeeId === u.employeeId);
			if (user) row.push(user.firstName, user.lastName);
		}
		questions.forEach((q) => {
			let found = a.answers.filter(
				(ans) => ans.questionId === q.questionId
			);
			found = sortAnswerOptions(q.options, found);
			row.push(
				found
					? JSON.stringify(
							found.map((r) => r.value).join(", "),
							replacer
					  )
					: ""
			);
		});
		ret.push(row);
	});
	return ret;
}

function sortAnswerOptions(options, answers) {
	let ret = answers.sort((a, b) => {
		let a_fi = options.findIndex((o) => o.optionId === a.optionId);
		let b_fi = options.findIndex((o) => o.optionId === b.optionId);
		return a_fi < b_fi ? -1 : 1;
	});
	return ret;
}
